// removed by extract-text-webpack-plugin
module.exports = {"font":"_3Szpp42qEWU_It2pELT6Oq","heading":"_3wp3CZU1nuG6RKns069W55","size14":"_2Il7fsObjm5cuGCPgntGM_","size15":"VW2XqfkqlXzMQOlOB_t1b"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Font/style.css
// module id = 419
// module chunks = 38